import { render, staticRenderFns } from "./CheckTable.vue?vue&type=template&id=88fe4928&scoped=true"
import script from "./CheckTable.vue?vue&type=script&lang=js"
export * from "./CheckTable.vue?vue&type=script&lang=js"
import style0 from "./CheckTable.vue?vue&type=style&index=0&id=88fe4928&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fe4928",
  null
  
)

export default component.exports